import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormMessageService } from '../form-message.service';
import { FormNotifyService } from '../form-notify.service';
import { FormErrorService } from '../error/form-error.service';
import { FormWizardService } from '../form-wizard.service';

import { CheckService } from '../check.service';
import { DataCheckService } from '../data-check.service';
import { EventService } from '../event.service';
import { ComponentManagerService } from '../component-manager.service';
import { FilterService } from '../filter-service';
import { KeybindingService } from '../keybinding-service';
import { LanguageService } from '../languag.service';

import { MenuStateService } from '../menu-state.service';
import { QuerystringService } from '../querystring';
import { RuntimeFrameworkService } from '../rtf-service';
import { NavigationEventService } from '../navigation-event.service';
import { NavigationService } from '../navigation.service';
import { ParamService } from '../param.service';
import { RouterService } from '../router.service';
import { ApplicationParamService } from '../application-param.service';
import { FilterConditionService } from '../filter-condition.service';
import { UserSettingsService } from '../user-settings.service';
import { UserSettingsToken } from '@farris/devkit';
import { WorkFlowMessage, WorkFlowMessageService } from '../work-flow/index';
/**
 * æ¨¡åçº§æ³¨å¥(å±20ä¸ª)
 */
const FARRIS_COMMAND_SERVICE_MODULE_PROVIDERS = [
  FormLoadingService,
  FormMessageService,
  FormNotifyService,
  FormErrorService,
  FormWizardService,
  CheckService,
  DataCheckService,
  EventService,
  ComponentManagerService,
  FilterService,
  KeybindingService,
  LanguageService,
  ParamService,
  MenuStateService,
  QuerystringService,
  RuntimeFrameworkService,
  NavigationEventService,
  NavigationService,
  RouterService,
  ApplicationParamService,
  FilterConditionService,
  { provide: UserSettingsToken, useClass: UserSettingsService },
  WorkFlowMessageService,
  WorkFlowMessage
];

export { FARRIS_COMMAND_SERVICE_MODULE_PROVIDERS }
